import React, { useContext } from "react";
import { makeStyles, Card, CardContent, Typography } from "@material-ui/core";
import Apiwelcome from "../../../Component/Paragraph/userapi/apiwelcome";
import { LangContext } from "../../../Context/Langcontext";
import { UserContext } from "../../../Context/UserContext";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "98%",
    height: "100%",
  },
  card: {
    width: "100%",
    height: "9rem",
    backgroundColor: "#f2f2f1",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    boxShadow: "1px 1px 3px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 3px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 3px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    overflowX: "auto",
  },
  cardapi: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "1rem",
    marginBottom: "1rem",
    // minHeight: "100%",
    // maxHeight: "auto",
  },
  maintext: {
    fontWeight: 700,
    fontSize: "1.2rem",
    color: "#595A5A",
  },
  cardcontent: { marginLeft: "2rem" },
  secondtext: {
    fontWeight: 200,
    fontSize: "1rem",
    color: "#595A5A",
  },
  textkey: {
    fontWeight: 400,
    fontSize: "1rem",
    color: "#595A5A",
    whiteSpace: "nowrap",
  },
  textvalue: {
    fontWeight: 200,
    fontSize: "1rem",
    color: "#595A5A",
    marginRight: "2rem",
    marginLeft: "0.5rem",
    whiteSpace: "nowrap",
  },
}));

const Welcomeapi = () => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const userContext = useContext(UserContext);
  const user = userContext.state;

  const convertDate = (date) => {
    const monthNames = [
      lang.January,
      lang.February,
      lang.March,
      lang.April,
      lang.May,
      lang.June,
      lang.July,
      lang.August,
      lang.September,
      lang.October,
      lang.November,
      lang.December,
    ];

    let dateObj = new Date(date);
    let month = monthNames[dateObj.getMonth()];
    let day = String(dateObj.getDate()).padStart(2, "0");
    let year = dateObj.getFullYear();

    let output = `${day} ${month} ${
      langContext.lang.locale === "th" ? Number(year + 543) : year
    }`;
    return output;
  };

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <CardContent className={classes.cardcontent}>
          <Typography className={classes.maintext}>
            {lang.Welcome} !!
          </Typography>
          <Typography className={classes.secondtext}>
            {lang.SubtitlesWelcome}
          </Typography>
          <div style={{ display: "flex" }}>
            <Typography className={classes.textkey}>{lang.Type} :</Typography>
            <Typography className={classes.textvalue}>
              {`${user.role
                .split("_")
                .join(" ")
                .charAt(0)
                .toUpperCase()}${user.role.split("_").join(" ").slice(1)}`}
            </Typography>
            <Typography className={classes.textkey}>
              {lang.Register} :
            </Typography>
            <Typography className={classes.textvalue}>
              {convertDate(user.created_at)}
            </Typography>
            {localStorage.getItem("role") === "contract" ||
            localStorage.getItem("role") === "public" ? (
              <>
                <Typography className={classes.textkey}>
                  {lang.Period} :
                </Typography>
                <Typography className={classes.textvalue}>
                  {user.contract
                    ? user.contract.start_date
                      ? `${
                          user.contract.start_date
                            ? convertDate(user.contract.start_date)
                            : "-"
                        } ${lang.To.toLowerCase()} ${
                          user.contract.end_date
                            ? convertDate(user.contract.end_date)
                            : "-"
                        }`
                      : "-"
                    : "-"}
                </Typography>
              </>
            ) : null}
          </div>
        </CardContent>
      </Card>

      <Card className={classes.cardapi}>
        <Apiwelcome />
      </Card>
    </div>
  );
};

export default Welcomeapi;
